import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  EntityMeta,
  OrganizationLicenseUpdatePayload,
} from '@qtek/shared/models';

export const OrganizationsActions = createActionGroup({
  source: 'Organizations Feature',
  events: {
    'Subscribe Organizations': props<{ mysid: string; params?: any }>(),
    'Unsubscribe Organizations': props<{ mysid: string }>(),
    'Get Organizations': emptyProps(),
    'Clear Organizations': emptyProps(),
    'Get Organizations Success': props<{
      payload: any[];
      meta?: EntityMeta;
    }>(),
    'Get Organizations Failure': props<{ payload: any[]; meta?: EntityMeta }>(),
    'Get Organization Details': props<{ id: string; params?: any }>(),
    'Get Organization Details Success': props<{ res: any }>(),
    'Get Organization Details Failure': props<{ error: Error }>(),
    'Get Organization Licenses': emptyProps(),
    'Get Organization Licenses Success': props<{ res: any }>(),
    'Get Organization Licenses Failure': props<{ error: Error }>(),
    'Update Organization Licenses': props<{
      payload: OrganizationLicenseUpdatePayload;
    }>(),
    'Update Organization Licenses Success': props<{ res: any }>(),
    'Update Organization Licenses Failure': props<{ error: Error }>(),

    'Delete Organization Account': props<{ acnId: string }>(),
    'Delete Organization Account Success': props<{ acnId: string }>(),
    'Delete Organization Account Failure': props<{ error: Error }>(),

    'Update Organization': props<{ id: string; testOrgFlg: boolean }>(),
    'Update Organization Success': props<{ res: any }>(),
    'Update Organization Failure': props<{ error: Error }>(),
    'Update Investor Profile Visibility': props<{
      id: string;
      visibility: 'pablic' | 'none';
    }>(),
    'Update Investor Profile Visibility Success': props<{
      res: { investorProfileVisibilityLevel: 'pablic' | 'none' };
    }>(),
    'Update Investor Profile Visibility Failure': props<{ error: Error }>(),

    'Update Feature Stage': props<{
      id: string;
      featureStg: string;
    }>(),
    'Update Feature Stage Success': props<{
      res: { featureStg: string };
    }>(),
    'Update Feature Stage Failure': props<{ error: Error }>(),

    'Update Organization User': props<{
      userId: string;
      payload: any;
    }>(),
    'Update Organization User Success': props<{
      userId: string;
      updatedUser: any;
    }>(),
    'Update Organization User Failure': props<{
      error: Error;
    }>(),

    'Reset User Password': props<{
      userId: string;
    }>(),
    'Reset User Password Success': props<{
      userId: string;
      message?: string;
    }>(),
    'Reset User Password Failure': props<{
      error: Error;
    }>(),

    'Reset User Password Link': props<{
      userId: string;
    }>(),
    'Reset User Password Link Success': props<{
      userId: string;
      link: string;
    }>(),
    'Reset User Password Link Failure': props<{
      error: Error;
    }>(),

    'Generate On Behalf Token': props<{
      userId: string;
    }>(),
    'Generate On Behalf Token Success': props<{
      userId: string;
      token: string;
    }>(),
    'Generate On Behalf Token Failure': props<{
      error: Error;
    }>(),

    'Login As Another User': props<{
      token: string;
    }>(),
    'Login As Another User Success': props<{
      userData: any;
    }>(),
    'Login As Another User Failure': props<{
      error: Error;
    }>(),

    'Update Organization Name': props<{
      acnId: string;
      name: string;
    }>(),
    'Update Organization Name Success': props<{
      res: any;
    }>(),
    'Update Organization Name Failure': props<{
      error: Error;
    }>(),

    'Add Organization Domain': props<{
      acnId: string;
      domain: string;
    }>(),
    'Add Organization Domain Success': props<{
      res: any;
    }>(),
    'Add Organization Domain Failure': props<{
      error: Error;
    }>(),

    'Remove Login Block': props<{ email: string }>(),
    'Remove Login Block Success': props<{ email: string; message?: string }>(),
    'Remove Login Block Failure': props<{ error: Error }>(),
  },
});
